import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FlatButton as MuiFlatButton,
  Dialog as MuiDialog
} from 'material-ui';
import { ifitBlack, ifitBlack54, scienceBlue } from '../../theme/colors';

const styles = {
  modal: {
    width: '85%',
    maxWidth: '500px'
  },
  modalLabel: {
    fontFamily: 'proxima-nova',
    fontWeight: 600,
    letterSpacing: '0.05rem',
    color: scienceBlue
  },
  title: {
    color: ifitBlack,
    fontFamily: 'proxima-nova',
    fontWeight: 600,
    marginBottom: '0',
    paddingBottom: '0'
  },
  content: {
    color: ifitBlack54,
    fontFamily: 'proxima-nova',
    lineHeight: 1.5
  }
};

export class ConfirmAccountModal extends Component {
  static propTypes = {
    handleModalClose: PropTypes.func.isRequired,
    noAccount: PropTypes.func.isRequired,
    isOpen: PropTypes.bool
  };

  render() {
    return (
      <MuiDialog
        className="confirm-account-modal"
        contentClassName="confirm-account-content"
        title={ 'Do you already have an iFit account?' }
        titleStyle={ styles.title }
        bodyStyle={ styles.content }
        contentStyle={ styles.modal }
        actions={ [
          <MuiFlatButton
            key="yes"
            label="Yes"
            labelStyle={ styles.modalLabel }
            hoverColor="transparent"
            rippleColor="transparent"
            onClick={ this.props.handleModalClose }
          />,
          <MuiFlatButton
            key="no"
            label="No"
            labelStyle={ styles.modalLabel }
            hoverColor="transparent"
            rippleColor="transparent"
            onClick={ this.props.noAccount }
          />
        ] }
        open={ this.props.isOpen }
        onRequestClose={ this.props.handleModalClose }
        actionsContainerStyle={{ textAlign: 'center' }}
        autoDetectWindowHeight={ false }
        style={{ textAlign: 'center' }}
      />
    );
  }
};

export default ConfirmAccountModal;
